// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"211":"00370ff3","467":"3f3af49e","525":"834b86b8","619":"5a3d6bc0","687":"7c9ce87d","755":"652a0676","848":"6a84fd8c","903":"ec939823","974":"890654fe","983":"a7eee935"}[chunkId] + ".chunk.js";
};